import { createAsyncThunk } from '@reduxjs/toolkit'
import { ResolveUrl } from 'features/firebase-app'
import { getBearerToken } from '../../application/application-slice'

export const annouce_device = createAsyncThunk<any, any, any>(
  'auto/announce/device',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(ResolveUrl('auto/announce/device'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        })
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const fetch_media_statistics = createAsyncThunk<any, any, any>(
  'auto/fetch/media/statistic',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(ResolveUrl('auto/fetch/media/statistic'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        })
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const get_customer_settings = createAsyncThunk<any, any, any>(
  'auto/get/customer/settings',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(ResolveUrl('auto/get/customer/settings'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        })
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const fetch_subtitles = createAsyncThunk<any, any, any>(
  'auto/fetch/media/subtitles',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(ResolveUrl('auto/fetch/media/subtitles'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        })
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)
